/**
 * 根据污染等级返回颜色
 * @param {Number|String} level 污染等级
 * @returns {Object}
 */
export function pollutionLevel(level) {
  const pollutionLevelList = [
    { label: "优", color: "#00e400", rgb: [0, 228, 0], img: require("@/assets/dataScreen/pollution_level_0.png") },
    { label: "良", color: "#ffce00", rgb: [255, 206, 0], img: require("@/assets/dataScreen/pollution_level_1.png") }, // #ffff00 rgb(255, 255, 0)
    { label: "轻度污染", color: "#ff7e00", rgb: [255, 126, 0], img: require("@/assets/dataScreen/pollution_level_2.png") },
    { label: "中度污染", color: "#ff0000", rgb: [255, 0, 0], img: require("@/assets/dataScreen/pollution_level_3.png") },
    { label: "重度污染", color: "#99004c", rgb: [153, 0, 76], img: require("@/assets/dataScreen/pollution_level_4.png") },
    { label: "严重污染", color: "#7e0023", rgb: [126, 0, 35], img: require("@/assets/dataScreen/pollution_level_5.png") },
  ];
  return pollutionLevelList[level];
}

/**
 * 根据污染类型及污染数值返回颜色
 * @param {String} type 污染类型 (AQI PM2.5 PM10 SO2 NO2 CO O3)
 * @param {Number} value
 */
export function pollutionTypeLevel(type, value) {
  let level = -1;
  const pollutionType = {
    AQI: [50, 100, 150, 200, 300],
    "PM2.5": [35, 75, 115, 150, 250],
    PM10: [50, 150, 250, 350, 420],
    SO2: [50, 150, 475, 800, 1600],
    NO2: [40, 80, 180, 280, 565],
    CO: [2, 4, 14, 24, 36],
    O3: [100, 160, 215, 265, 800],
  };
  if (value && !isNaN(Number(value))) {
    level = pollutionType[type].findIndex((item) => item + 1 > value);
  }
  return pollutionLevel(level);
}

export function formatValue(value) {
  return value == null ? "--" : value
}
